import React from 'react'

import { useUnit } from 'effector-react'

import { useEffect, useState } from 'hooks'

import { showFailToast } from 'app/redux/actions/ui'
import { get2faDetails } from 'app/redux/api/2fa'
import { ApiError } from 'app/redux/models/errors'

import { TwoFactorConfirmSms } from 'components/_old/TwoFactorAwait/components/TwoFactorConfirmSms'

import { SmsCodeIssue } from 'components/organisms/SmsCodeForm/CodeIssue'

import { useSmsSend } from 'app/pages/Dashboard/UserProfile/hooks'

import { $isIssueShown } from './model'

type TextMessageProps = {
  query: Record<string, string>
  onAccept: () => void
  setIsPhoneVerified?: (flag: boolean) => void
  shouldRememberBrowser: boolean
  setShouldRememberBrowser: (value: boolean) => void
}

const TextMessage = ({
  query,
  onAccept,
  setIsPhoneVerified,
  shouldRememberBrowser,
  setShouldRememberBrowser,
}: TextMessageProps): React.ReactElement => {
  const [phone, setPhone] = useState('')

  const [isIssueShown] = useUnit([$isIssueShown])

  const { client_id: clientId, token } = query

  const fetchPhoneNumber = async (): Promise<string | undefined> => {
    const response = await get2faDetails({ clientId, token })

    if (response instanceof ApiError) {
      showFailToast()
      return
    }

    const phoneNumber = (response?.phone_verified && response?.phone) || ''

    setPhone(phoneNumber)
    if (setIsPhoneVerified) setIsPhoneVerified(!!phoneNumber)
  }

  useEffect(() => {
    fetchPhoneNumber()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const {
    isLoading: isSendingSms,
    blockedText,
    handleSmsSend,
  } = useSmsSend({ action: 'login', clientId, token, onSuccessSmsSend: () => {} })

  const handleSendSms = (): void => {
    handleSmsSend({ phone })
  }

  if (isIssueShown) {
    return <SmsCodeIssue isLogin hideHeader />
  }

  return (
    <TwoFactorConfirmSms
      query={query}
      step="enterSms"
      phone={phone}
      isSendingSms={isSendingSms}
      blockedText={blockedText}
      onAccept={onAccept}
      shouldRememberBrowser={shouldRememberBrowser}
      setShouldRememberBrowser={setShouldRememberBrowser}
      handleSendSms={handleSendSms}
    />
  )
}

export { TextMessage }
